<template>
	<div class="feedPage" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader bag="#fff" />
		<fuHeader />
		<div class="zlmwBag" :class="{ hide: !imgFlag }">
			<!-- <lunbo v-if="iUrl.length" :imgArr = 'iUrl' lbHeight = '450'/> -->
			<img v-if="iUrl" :src="$imgUrl + iUrl" alt="" />
			<img v-if="!iUrl" src="@/assets/img/bgm.png" alt="" />
		</div>
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="zlmwBox">
				<div class="gxBoxRT">
					<div class="gxBoxRTit">
						<h2>{{ tabTxt }}推荐</h2>
						<span @click="czFn">
							<img src="@/assets/img/sxIcon.svg" alt="" />
							重置
						</span>
					</div>
					<div class="gxBoxRTbox">
						<div class="gxBoxRTitem supHove3" :class="{ active: keywords.includes(item) }" @click="tabFn(item)" v-for="(item, index) in tabList" :key="index">
							{{ item }}
						</div>
					</div>
				</div>
				<div class="zzAdminConts" v-if="perData.length">
					<div class="zzAdminCont">
						<div class="zzAdminG supHove5" v-for="item in perData" :key="item.webpageResourceId">
							<div class="zzAdminItemImg zzAdminItemImg1" @click="btnFn(item)">
								<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
							</div>
							<div class="zzAdminItemP" @click="btnFn(item)">
								<div class="zzAdminItemTit">
									<p :title="item.title">{{ item.title }}</p>
									<div class="zzAdminItemYuy" @click.stop="scFn(item)" :class="item.isCollect ? 'active' : ''">
										<img src="@/assets/img/sc (4).svg" v-show="!item.isCollect" alt="" />
										<img src="@/assets/img/sc (2).svg" v-show="item.isCollect" alt="" />
										<span>{{ item.isCollect ? '已收藏' : '收藏' }}</span>
									</div>
								</div>
								<div class="zzAdminItemJj" v-if="item.keywords">
									<div class="zzAdminItemJjI" :class="`zzAdminItemJjI${(tabList.indexOf(i) + 1) % 6}`" v-for="(i, index) in item.keywords?.split(',')" :key="index">
										{{ i }}
									</div>
								</div>
								<div class="zzAdminItemC" v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></div>
								<div class="zzAdminItemFot">
									<div class="zzAdminItemk">日期：{{ (item.releaseTime || item.createTime) | momentYR('YYYY年MM月DD日') }}</div>
									<!-- <div class="zzAdminItemk">
					  编写人：{{item.createNickName}}
					</div> -->
								</div>
							</div>
						</div>
					</div>
					<fenye :total="total" ref="fybox" @dataFn="perList" />
				</div>
				<div class="zzAdminConts" v-else>
					<el-empty description="暂无信息"></el-empty>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import userHeader from '@/components/hearder/userHeader';
import foot from '@/components/foot/foot';
import fenye from '@/components/pubComponents/fenye';
import fuHeader from '@/components/hearder/fuHeader';
import lunbo from '@/components/pubComponents/lunbo';

export default {
	name: 'zlmwHome',
	data() {
		return {
			flag: 0,
			flags: 0,
			tabList: [],
			tabType: 3, // 1 歌曲 2 演讲 3 美文
			perData: [],
			keywords: '',
			fullscreenLoading: false,
			iUrl: '',
			imgFlag: false,
			arrs: [
				{
					name: '文章类',
					type: 3
				},
				{
					name: '歌曲类',
					type: 1
				},
				{
					name: '演讲类',
					type: 2
				},
				{
					name: '电影类',
					type: 4
				},
				{
					name: '最新试卷',
					type: 5
				},
				{
					name: '每期课件',
					type: 6
				},
				{
					name: '同步课件',
					type: 7
				}
			],
			total: 0
		};
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		fenye,
		lunbo
	},
	watch: {
		'$route.query': {
			handler(newVal, oldVal) {
				console.log(newVal, 33333);
				let { tabType } = this.$route.query;
				this.tabType = tabType || 3;
				this.init();
			},
			deep: true // 如果需要深度监听，例如对象内部属性的变化。这里通常用于复杂对象或数组。对于简单的参数变化，可以忽略这个选项。
		}
	},
	computed: {
		tabTxt() {
			let val = '';
			switch (this.tabType) {
				case '1':
					val = '歌曲';
					break;
				case '2':
					val = '演讲';
					break;
				case '3':
					val = '美文';
					break;
			}
			return val;
		}
	},
	methods: {
		scFn(item) {
			this.$scFn(
				{
					type: '1',
					assetsId: item.webpageResourceId
				},
				item.isCollect,
				this.perList,
				{
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				}
			);
		},
		czFn() {
			this.keywords = '';
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabFn(item) {
			if (this.keywords.includes(item)) {
				this.keywords = this.keywords.replace(item + ',', '');
			} else {
				this.keywords += item + ',';
			}
			if (this.$refs['fybox']) {
				this.$refs['fybox'].pageNum = 1;
				this.$refs['fybox'].pageSize = 10;
			}
			this.perList({
				pageNum: 1,
				pageSize: 10
			});
		},
		tabBtn(item, index) {
			this.flags = index;
			this.tabType = item.type;
		},
		btnFn(item) {
			sessionStorage.removeItem('classificationId');
			if (this.tabType == 4) {
				this.$router.push({
					path: 'dianyingHome'
				});
			} else if (this.tabType == 5) {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						tabFtxt: '最新试卷'
					}
				});
			} else if (this.tabType == 6) {
				this.$router.push({
					path: 'kejianTj',
					query: {
						type: 1,
						tabFtxt: '每期课件'
					}
				});
			} else if (this.tabType == 7) {
				this.$router.push({
					path: 'gongxiangHz',
					query: {
						yzType: '2',
						tabFtxt: '同步课件'
					}
				});
			} else {
				let a = ['首页'];
				if (this.tabType == 1) {
					a.push('歌曲列表');
				} else if (this.tabType == 2) {
					a.push('演讲列表');
				} else if (this.tabType == 3) {
					a.push('美文列表');
				} else if (this.tabType == 4) {
					a.push('电影列表');
				}
				this.$router.push({
					path: 'scDec',
					query: {
						type: this.tabType,
						txt: item.title,
						webpageResourceId: item.webpageResourceId,
						crumFlag: 1,
						tabFtxt: a
					}
				});
			}
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydWebpageResource/list', {
					params: {
						keywords: this.keywords,
						type: this.tabType,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			this.$http
				.get('api/app/yydBanner/list', {
					params: {
						type: 5
					}
				})
				.then((res) => {
					this.imgFlag = true;
					setTimeout(() => {
						this.imgFlag = false;
					}, 5000);
					if (res.code == 200) {
						console.log(res, 999);
						if (res.data.length) {
							// 1 歌曲 2 演讲 3 美文
							this.iUrl = res.data.filter((item) => {
								return this.tabTxt == item.name;
							})[0].bannerImg;
						}
					}
				});
			// 关键字 1 歌曲 2 演讲 3 美文 4 电影
			this.$http
				.get('api/app/yydWebpageResource/webpageResourceKeywords/list', {
					params: {
						type: this.tabType
					}
				})
				.then((res) => {
					if (res.code == 200) {
						this.tabList = res.data.map((item) => {
							return item.resourceKeywordsName;
						});
						console.log(this.tabList, 8888);
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 12
			});
		}
	},
	mounted() {
		let { tabType } = this.$route.query;
		this.tabType = tabType || 3;
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.zlmwBag {
	height: 450px;
	&.hide {
		height: 0;
		transition: all 0.3s ease-in;
	}
	img {
		height: 100%;
		width: 100%;
		object-fit: cover;
	}
}
.zlmwBox {
	width: 1200px;
	margin: 10px auto 0;
}
.feedPage {
	background: #f5f5f5;
	.feedBox {
		min-height: calc(100vh - 123px);
		width: 1200px;
		margin: 10px auto 0;
		box-sizing: border-box;
		display: flex;
		.feedLeft {
			width: 140px;
			margin-right: 10px;
			background: #fff;
			padding: 35px 20px 35px 14px;
			box-sizing: border-box;
			height: 164px;
			.feedItem {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 36px;
				cursor: pointer;
				font-size: 16px;
				font-weight: bold;
				&:last-of-type {
					margin-bottom: 0;
				}
				img {
					width: 30px;
					height: 30px;
					margin-right: 8px;
				}
				span {
					color: #333333;
					font-size: 16px;
				}
			}
			.active {
				span {
					color: #1d7b3a;
				}
			}
		}
		.feedRight {
			flex: 1;
			background: #fff;
		}
	}
}
.zzAdminConts {
	background: #ffffff;
	border-radius: 0px 0px 6px 6px;
	padding: 0 15px;
	margin-bottom: 10px;
	.zzAdminCont {
		margin-bottom: 30px;
		.zzAdminG {
			display: flex;
			padding: 15px 0;
			border-bottom: 1px solid #f8f8f8;
			align-items: center;
			&:last-of-type {
				border-bottom: none;
			}
			.zzAdminItemImg {
				width: 149px;
				height: 99px;
				margin-right: 10px;
				cursor: pointer;
			}
			.zzAdminItemP {
				flex: 1;
				cursor: pointer;
				.zzAdminItemJj {
					display: flex;
					align-items: center;
					.zzAdminItemJjI {
						padding: 0 10px;
						height: 20px;
						font-size: 12px;
						text-align: center;
						line-height: 20px;
						border-radius: 4px;
						margin-right: 10px;
						margin-bottom: 5px;
					}
					.zzAdminItemJjI0 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI1 {
						background: #fef7f0;
						color: #f7860f;
					}
					.zzAdminItemJjI2 {
						background: #f6fcf1;
						color: #5ec009;
					}
					.zzAdminItemJjI3 {
						background: #f1f7fe;
						color: #1675e5;
					}
					.zzAdminItemJjI4 {
						background: #fbf3ff;
						color: #bf2ff9;
					}
					.zzAdminItemJjI5 {
						background: #f2f7f3;
						color: #1d7b3a;
					}
				}
				.zzAdminItemFot {
					display: flex;
					align-items: center;
					.zzAdminItemk {
						display: flex;
						align-items: center;
						color: #8f9190;
						font-size: 12px;
						margin-right: 29px;
						img {
							width: 15px;
							height: 15px;
							margin-right: 4px;
						}
					}
				}
				.zzAdminItemC {
					color: #000000;
					font-size: 14px;
					width: 951px;
					height: 20px;
					margin-bottom: 5px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
				.zzAdminItemTit {
					display: flex;
					align-items: center;
					margin-bottom: 6px;
					.zzAdminItemStat {
						width: 44px;
						height: 20px;
						background: #1d7b3a;
						font-size: 14px;
						color: #fff;
						margin-right: 10px;
						border-radius: 4px;
						text-align: center;
						line-height: 20px;
					}
					p {
						font-size: 16px;
						color: #000000;
						font-weight: bold;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
						max-width: 800px;
					}
					.zzAdminItemYuy {
						display: flex;
						align-items: center;
						color: #999999;
						font-size: 14px;
						margin-left: 25px;
						line-height: 1;
						img {
							width: 14px;
							height: 14px;
							vertical-align: bottom;
							margin-right: 5px;
						}
					}
					.active {
						color: #1d7b3a;
					}
				}
			}
			.zzAdminItemDel {
				flex: 1;
				width: 20px;
				height: 22px;
				margin-right: 32px;
				cursor: pointer;
				text-align: right;
			}
		}
	}
}
.gxBoxRT {
	background: #ffffff;
	border-radius: 6px;
	margin-bottom: 10px;
	padding: 17px 17px 11px;
	.gxBoxRTbox {
		display: flex;
		flex-wrap: wrap;
		max-height: calc(30px + 10px + 30px);
		overflow: hidden;
		.gxBoxRTitem {
			padding: 0 10px;
			height: 30px;
			background: #f3f4f7;
			border-radius: 4px;
			text-align: center;
			line-height: 30px;
			color: #000000;
			font-size: 14px;
			cursor: pointer;
			margin-right: 20px;
			margin-bottom: 10px;
			// &:nth-of-type(14n){
			//   margin-right: 0;
			// }
		}
		.active {
			background: #e5f2e9;
			color: #1d7b3a;
		}
	}
	.gxBoxRTit {
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 14px;
		color: #949494;
		margin-bottom: 20px;

		span {
			display: flex;
			align-items: center;
			cursor: pointer;
		}
		img {
			width: 16px;
			height: 16px;
			margin-right: 4px;
		}
	}
}
</style>
